/**
 * common helper methods
 */
 export const thisBaseURL = "/Fair";

 export const checkRedirect = function (responseTxt) {
    let redirect = false;
    //console.log("Error response: " + responseTxt);
    if(responseTxt && responseTxt.startsWith('<!doctype html>')){
	   redirect = true;
	   //console.log("Check Redirect flag: "+redirect);
	 }

    //console.log("Redirect flag: "+redirect);
    return redirect;
}

export const emptyCache = function(){
    if('caches' in window){
      caches.keys().then((names) => {
        names.forEach(name => {
           caches.delete(name);
        })
      });
     // window.location.reload(true);
    }
   window.history[0] = window.history[window.history.length - 1];
   let historyLen = window.history.length;   
   window.history.go(-historyLen);
   window.history.index =0;
   // console.log("In empty");
}

/**
*
*  Base64 encode / decode
*  http://www.webtoolkit.info/
*
**/
export const Base64 = {
    // private property
    _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    // public method for encoding
    encode : function (input) {
        let output = "";
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        let i = 0;
        input = Base64._utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
            this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
            this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        }
        return output;
    },
    // public method for decoding
    decode : function (input) {
        let output = "";
        let chr1, chr2, chr3;
        let enc1, enc2, enc3, enc4;
        let i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = Base64._utf8_decode(output);
        return output;
    },
    // private method for UTF-8 encoding
    _utf8_encode : function (string) {
        string = string.replace(/\r\n/g,"\n");
        let utftext = "";
        for (let n = 0; n < string.length; n++) {
            let c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    },
    // private method for UTF-8 decoding
    _utf8_decode : function (utftext) {
        let string = "";
        let i = 0;
        let c = 0; 
        let c2 = 0;
        let c3 = 0;
        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}
export const emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/i;
export const passRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i;

function padTo2Digits(num) {
  return String(num).padStart(2, '0');
}

export const generateUUID = function(){
    let d = new Date();
    let forRd = new Date().getTime();
    let uuid = 'xxyx-ixxx-yxxx'.replace(/[xy]/g, function(c) {
        let r = (forRd + Math.random()*16)%16 | 0;
        forRd = Math.floor(forRd/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    let month = d.getMonth();
    month = padTo2Digits( (month + 1).toString() );
    const day = padTo2Digits( d.getDate().toString());
    const year = d.getFullYear().toString().substr(-2);
    const hoursAndMinutes =padTo2Digits(d.getHours()) + padTo2Digits(d.getMinutes());
    uuid = year+month+day+hoursAndMinutes+"-"+uuid;
    return uuid;
};

export const getTodayYYYYMMDD = function(){
	let today = new Date();
	let dd = padTo2Digits(today.getDate().toString());
	//January is 0
	let mm = today.getMonth()+1;
	let  month = padTo2Digits( mm.toString());
	let yyyy = today.getFullYear();

	today = yyyy+'-'+month+'-'+dd;
	return today;
};

export const santizeFileName = function(inputStr){
	if(!inputStr){ return "";}
    let  origFileName=  inputStr.split(' ').join('-');
    return origFileName;

};